import {ShapeCommand} from '../commands.template';

export class ActivityChangeStyleCommand extends ShapeCommand {
  services: any;
  firstAction;
  boolean;
  reverseStyleChange: any;
  constructor(data) {
    super(data);
    this.firstAction = true;
  }

  public prepareData() {
    const activityJson = this.services.jsonHandlerSvc.get().activities.find(a => {
      return Number(a.mxKey) === Number(this.object.mxKey);
    });

    this.reverseStyleChange = {
      mxKey: activityJson.mxKey,
      style: activityJson.style,
      customStyle: activityJson.customStyle
    };

    return this;
  }

  public execute() {
    super.execute();

    return this.sendChanges(this.object);
  }

  public reverse() {
    super.reverse();

    return this.sendChanges(this.reverseStyleChange);
  }

  private sendChanges(styleChange) {
    const action: any = {
      changeActivity: {
        mxKey: styleChange.mxKey,
        customStyle: styleChange.customStyle
      }
    };

    if (styleChange.customStyle) {
      action.changeActivity.style = styleChange.style;
    }

    this.services.diagramUpdateSvc.update(action);
    this.services.editorRegistrySvc
      .getGraph()
      .model.getCell(styleChange.mxKey)
      .comp.instance.setupFromJson();
  }
}
